import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { ITransactionPostingPeriodResponse } from '../interface/transactionPosting';

interface IFetchTransactionPostingPeriod {
  id?: string;
  relations?: string[];
  extraFilters?: Record<string, string | number>;
}
export const useFetchTransactionPostingPeriod = (
  params: IFetchTransactionPostingPeriod,
  enabled: boolean,
) => {
  const { extraFilters, ...rest } = params;
  const queryString = new URLSearchParams(
    Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
  );
  Object.entries(extraFilters ?? {}).forEach(([key, value]) => {
    queryString.append(`filter.${key}`, String(value));
  });

  const transactionPostingUrl = `${API_URLS.TRANSACTION_POSTING_PERIOD}`;
  const url = queryString ? `${transactionPostingUrl}?${queryString}` : transactionPostingUrl;
  const query = useQuery<ITransactionPostingPeriodResponse, Error>({
    queryKey: ['transaction-posting-periods', url],
    queryFn: async () => {
      const response = await get(url);
      return response;
    },
    enabled: enabled,
  });

  return query;
};
